import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export default function useDeleteProductKnowledgeArticle() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (articleId: string) => api.delete(`/admin/product-knowledge/${articleId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'product-knowledge'] });
    },
  });
}
